import * as React from "react";
import { Button,ButtonGroup,  Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import { ICustomMutantPropsData, ICustomMutantPropsFunctions } from "../props/ICustomMutantProps";
import IJobCalculation from "../interfaces/IJobCalculation";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglassStart, faSpinner, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { calculationStatusIcons, calculationStatusNames } from "../../../settings";
import MutantTable from './TableCustomMutant';
import { columnsCustomMutant } from "../../../TableColumns";
import IMainState from '../../../IMainState';
library.add(faHourglassStart, faSpinner, faCheck, faTimes);

type IProps = ICustomMutantPropsData & ICustomMutantPropsFunctions;


class CustomMutantComponent extends React.Component<IProps> {

    state = {
        CustomMutant: null,   
    }
    
    clear() {
        this.props.clearMutations()
    } 

    generateSequence(){

        var fileName = prompt("Please provide the name of the constructed sequence", "custom_sequence.fasta");
        if(fileName != null){
            this.props.generateCustomMutantSequence(this.props.jobId, fileName, this.props.CustomMutation)
        }
    }
    
    removeFromCustomMutant = (row) => {
        this.props.removeCustomMutantMutations(row);
     }

    render() {
        return <div className="mutantComponent">
             <ButtonGroup variant="outlined" aria-label="outlined primary button group" style={{ width: "100%",}}>
                <Button onClick={() => this.clear()} style={{borderColor: "black", margin: 0}}>
                    Clear
                </Button>
                <Button onClick={() => this.generateSequence()} style={{borderColor: "black", margin: 0}}>
                    Generate sequence
                </Button>
            </ButtonGroup>
        <MutantTable 
                key={0}
                data={this.props.CustomMutation}
                columns={columnsCustomMutant} 
                //setSelectedRows={r => this.setState({ selectedBTC: r })}
                removeFromCustomMutant={this.removeFromCustomMutant} 
                />
    </div>
    }
    
}

export default CustomMutantComponent;
